import { COUNTRIES, LAUNCH_START, dateKey, parseDay, addDays, getEstimate, dateRange } from './smallsmore-mcase-shipping-model.js?v=20261018-7-12';

const section = document.querySelector('[data-shipping-section]');
const params = new URLSearchParams(location.search);
let countryCode = Object.hasOwn(COUNTRIES, params.get('country')) ? params.get('country') :
  (Object.hasOwn(COUNTRIES, window.Shopify?.country) ? window.Shopify.country : 'US');
let today = new Date();
let month = new Date(today.getFullYear(), today.getMonth(), 1, 12);
let highlight = 'all';
let selectedDay = null;
const svg = (direction) => `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="${direction === 'left' ? 'M15 6 9 12l6 6' : 'm9 6 6 6-6 6'}" stroke="currentColor" stroke-width="1.6"/></svg>`;
const fullDay = date => date.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
const between = (date, min, max) => min && max && date >= min && date <= max;

function launchCopy() {
  if (dateKey(today) < LAUNCH_START) return 'We’ll begin shipping next week, in the order we receive your orders.';
  return 'Shipping is underway. We’re dispatching orders in the order they were received.';
}
function paragraphCopy() {
  return `<p>${launchCopy()}</p><p>Production has just started, and we expect it to take around a week to ramp up. Orders are estimated to dispatch in <strong>7–12 days</strong>.</p><p>We’re working to improve production efficiency and get your MCase on its way as quickly as we can. Thank you for your patience.</p>`;
}
function countryControl() {
  return `<div class="sm-ship__destination"><span id="shipping-country-label">Delivering to</span><div class="sm-ship__country-picker">
    <button type="button" id="shipping-country" class="sm-ship__country-toggle" data-country="${countryCode}" aria-haspopup="listbox" aria-expanded="false" aria-controls="shipping-country-options" aria-labelledby="shipping-country-label shipping-country-name" aria-describedby="shipping-estimate-note"><span id="shipping-country-name">${COUNTRIES[countryCode].name}</span><svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m6 9 6 6 6-6" stroke="currentColor" stroke-width="1.6"/></svg></button>
    <div id="shipping-country-options" class="sm-ship__country-menu" role="listbox" aria-labelledby="shipping-country-label" hidden>${Object.entries(COUNTRIES).map(([code, country]) => `<button type="button" role="option" tabindex="-1" data-country="${code}" aria-selected="${code === countryCode}"><span>${country.name}</span><span class="sm-ship__country-check" aria-hidden="true">✓</span></button>`).join('')}</div>
  </div></div>`;
}
function policyNote(estimate) {
  return `<p class="sm-ship__estimate-note" id="shipping-estimate-note">${estimate.arrivalMin ? `Based on our shipping policy · ${estimate.country.min}–${estimate.country.max} business days in transit. ${estimate.country.note ? estimate.country.note + ' ' : ''}Timing depends on your address and shipping method. Public holidays may affect these dates.` : 'No delivery estimate for this destination yet. Availability and timing need confirmation at checkout.'}</p>`;
}
function calendar(estimate) {
  const firstDay = (month.getDay() + 6) % 7;
  const gridStart = addDays(month, -firstDay);
  const daysInMonth = new Date(month.getFullYear(), month.getMonth() + 1, 0).getDate();
  const count = Math.ceil((firstDay + daysInMonth) / 7) * 7;
  const cells = Array.from({ length: count }, (_, index) => {
    const date = addDays(gridStart, index);
    const key = dateKey(date);
    const shipping = Boolean(between(date, estimate.dispatchMin, estimate.dispatchMax));
    const arrival = Boolean(between(date, estimate.arrivalMin, estimate.arrivalMax)) && ![0, 6].includes(date.getDay());
    const isToday = key === dateKey(today);
    const classes = ['sm-ship__day', date.getMonth() !== month.getMonth() ? 'is-outside' : '',
      shipping && highlight !== 'arrival' ? 'is-shipping' : '', arrival && highlight !== 'dispatch' ? 'is-arrival' : '',
      isToday ? 'is-today' : '', selectedDay === key ? 'is-selected' : ''].filter(Boolean).join(' ');
    const info = [isToday ? 'Today' : '', shipping ? 'Estimated dispatch window' : '', arrival ? 'Estimated delivery window' : ''].filter(Boolean).join('. ');
    return `<button class="${classes}" type="button" data-day="${key}" aria-label="${fullDay(date)}${info ? `. ${info}` : ''}" aria-pressed="${selectedDay === key}"${isToday ? ' aria-current="date"' : ''}><span>${date.getDate()}</span></button>`;
  }).join('');
  const selected = selectedDay ? parseDay(selectedDay) : null;
  let detail = 'Click a date to explore the highlighted windows.';
  if (selected) {
    const notes = [];
    if (selectedDay === dateKey(today)) notes.push('Today');
    if (between(selected, estimate.dispatchMin, estimate.dispatchMax)) notes.push('Estimated dispatch window');
    if (between(selected, estimate.arrivalMin, estimate.arrivalMax) && ![0, 6].includes(selected.getDay())) notes.push('Estimated delivery window');
    detail = `${selected.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })} · ${notes.join(' · ') || 'Outside the estimated windows'}`;
  }
  return `<div class="sm-ship__calendar" aria-label="Shipping calendar">
    <span class="sm-ship__corner sm-ship__corner--tl" aria-hidden="true"></span><span class="sm-ship__corner sm-ship__corner--tr" aria-hidden="true"></span><span class="sm-ship__corner sm-ship__corner--bl" aria-hidden="true"></span><span class="sm-ship__corner sm-ship__corner--br" aria-hidden="true"></span>
    <div class="sm-ship__cal-top"><span class="sm-ship__cal-label">[ MCASE / SHIPPING ]</span><button type="button" class="sm-ship__today" data-today>Today · ${today.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}</button></div>
    <div class="sm-ship__month-nav"><button type="button" class="sm-ship__month-button" data-month="-1" aria-label="Previous month">${svg('left')}</button><h3>${month.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}</h3><button type="button" class="sm-ship__month-button" data-month="1" aria-label="Next month">${svg('right')}</button></div>
    <div class="sm-ship__weekdays" aria-hidden="true">${['M','T','W','T','F','S','S'].map(d => `<span>${d}</span>`).join('')}</div>
    <div class="sm-ship__dates">${cells}</div>
    <div class="sm-ship__legend" aria-label="Calendar legend"><span><i class="today"></i>Today</span><span><i class="dispatch"></i>Dispatch</span><span><i class="arrival"></i>Delivery estimate</span></div>
    <div class="sm-ship__filters" aria-label="Calendar highlight"><button type="button" data-highlight="all" aria-pressed="${highlight === 'all'}">All dates</button><button type="button" data-highlight="dispatch" aria-pressed="${highlight === 'dispatch'}">Dispatch</button><button type="button" data-highlight="arrival" aria-pressed="${highlight === 'arrival'}"${estimate.arrivalMin ? '' : ' disabled'}>Delivery</button></div>
    <p class="sm-ship__date-detail" role="status">${detail}</p>
    <div class="sm-ship__readout"><span>STATUS: <b>${dateKey(today) <= '2026-10-11' ? 'PRODUCTION RAMP-UP' : 'MADE TO ORDER'}</b></span><span class="sm-ship__dots" aria-hidden="true">${'<i></i>'.repeat(9)}</span></div>
  </div>`;
}
function summary(estimate) {
  const arrival = dateRange(estimate.arrivalMin, estimate.arrivalMax);
  const dispatch = dateRange(estimate.dispatchMin, estimate.dispatchMax);
  return `<div class="sm-ship__summary" aria-live="polite"><div><span class="sm-ship__metric-label">ESTIMATED DISPATCH</span><strong data-dispatch-range>${dispatch}</strong><small>7–12 days to dispatch</small></div><div><span class="sm-ship__metric-label">${estimate.arrivalMin ? 'ESTIMATED DELIVERY' : 'DELIVERY TIMING'}</span><strong data-arrival-range>${arrival}</strong><small>${estimate.arrivalMin ? 'For an order placed today' : 'Destination timing not yet confirmed'}</small></div></div>`;
}
function render() {
  const estimate = getEstimate(today, countryCode);
  section.className = 'sm-ship sm-ship--a';
  section.dataset.option = 'a';
  section.innerHTML = `<div class="sm-ship__inner"><div class="sm-ship__left">${calendar(estimate)}</div><div class="sm-ship__right"><p class="sm-ship__eyebrow">MCase / Shipping update</p><h2 id="shipping-heading">Made with care.<br>On its way soon.</h2><div class="sm-ship__copy">${paragraphCopy()}</div>${countryControl()}${summary(estimate)}${policyNote(estimate)}</div></div>`;
  const url = new URL(location.href);
  url.searchParams.set('country', countryCode);
  history.replaceState(null, '', url);
}
function focusSection(target = 'section') {
  if (target === 'page') { scrollTo({ top: 0, behavior: 'instant' }); return; }
  const element = target === 'launch' ? document.querySelector('#launch-note') : section;
  const context = target === 'launch' ? 75 : innerWidth <= 749 ? 32 : 72;
  scrollTo({ top: Math.max(0, element.getBoundingClientRect().top + scrollY - context), behavior: 'instant' });
}
function chooseCountry(code) {
  if (!Object.hasOwn(COUNTRIES, code)) return;
  countryCode = code;
  selectedDay = null;
  if (countryCode === 'OTHER' && highlight === 'arrival') highlight = 'all';
  if (highlight === 'arrival') {
    const estimate = getEstimate(today, countryCode);
    month = new Date(estimate.arrivalMin.getFullYear(), estimate.arrivalMin.getMonth(), 1, 12);
  }
  render();
  section.querySelector('#shipping-country').focus({ preventScroll: true });
}
function closeCountryMenu(refocus = false) {
  const menu = section.querySelector('#shipping-country-options');
  if (menu.hidden) return;
  menu.hidden = true;
  const trigger = section.querySelector('#shipping-country');
  trigger.setAttribute('aria-expanded', 'false');
  if (refocus) trigger.focus({ preventScroll: true });
}
function focusCountryOption(menu, option) {
  option.focus({ preventScroll: true });
  const top = option.offsetTop, bottom = top + option.offsetHeight;
  if (top < menu.scrollTop) menu.scrollTop = top;
  else if (bottom > menu.scrollTop + menu.clientHeight) menu.scrollTop = bottom - menu.clientHeight;
}
function openCountryMenu(edge) {
  const menu = section.querySelector('#shipping-country-options');
  const trigger = section.querySelector('#shipping-country');
  const rect = trigger.getBoundingClientRect();
  const bounds = section.getBoundingClientRect();
  const below = Math.min(innerHeight, bounds.bottom) - rect.bottom - 16;
  const above = rect.top - Math.max(16, bounds.top + 8);
  const openAbove = below < 360 && above > below;
  menu.classList.toggle('is-above', openAbove);
  menu.style.maxHeight = `${Math.max(88, Math.min(360, openAbove ? above : below))}px`;
  menu.hidden = false;
  trigger.setAttribute('aria-expanded', 'true');
  const options = [...menu.querySelectorAll('[role="option"]')];
  const active = edge === 'first' ? options[0] : edge === 'last' ? options.at(-1) : options.find(o => o.getAttribute('aria-selected') === 'true');
  focusCountryOption(menu, active);
}
section.addEventListener('keydown', event => {
  const picker = event.target.closest('.sm-ship__country-picker');
  if (!picker) return;
  const menu = picker.querySelector('[role="listbox"]');
  if (event.key === 'Escape' && !menu.hidden) { event.preventDefault(); closeCountryMenu(true); return; }
  if (event.key === 'Tab') { closeCountryMenu(); return; }
  if (menu.hidden && ['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
    event.preventDefault();
    openCountryMenu(event.key === 'ArrowUp' || event.key === 'End' ? 'last' : 'first');
    return;
  }
  if (menu.hidden) return;
  const options = [...menu.querySelectorAll('[role="option"]')];
  const index = options.indexOf(event.target.closest('[role="option"]'));
  let next;
  if (event.key === 'ArrowDown') next = options[(index + 1) % options.length];
  else if (event.key === 'ArrowUp') next = options[(index - 1 + options.length) % options.length];
  else if (event.key === 'Home') next = options[0];
  else if (event.key === 'End') next = options.at(-1);
  else if (event.key.length === 1 && !event.ctrlKey && !event.metaKey && event.key !== ' ') next = [...options.slice(index + 1), ...options.slice(0, index + 1)].find(o => o.textContent.trim().toLowerCase().startsWith(event.key.toLowerCase()));
  if (next) { event.preventDefault(); focusCountryOption(menu, next); }
});
document.addEventListener('pointerdown', event => { if (!event.target.closest('.sm-ship__country-picker')) closeCountryMenu(); });
section.addEventListener('focusout', event => { if (event.target.closest('.sm-ship__country-picker') && !event.relatedTarget?.closest('.sm-ship__country-picker')) closeCountryMenu(); });
window.addEventListener('resize', () => closeCountryMenu());
section.addEventListener('click', event => {
  const button = event.target.closest('button');
  if (!button || !section.contains(button) || button.disabled) return;
  if (button.id === 'shipping-country') {
    if (button.getAttribute('aria-expanded') === 'true') closeCountryMenu(true);
    else openCountryMenu();
    return;
  }
  if (button.hasAttribute('data-country')) { chooseCountry(button.dataset.country); return; }
  let refocus;
  if (button.dataset.month) {
    month = new Date(month.getFullYear(), month.getMonth() + Number(button.dataset.month), 1, 12);
    refocus = `[data-month="${button.dataset.month}"]`;
  } else if (button.hasAttribute('data-today')) {
    month = new Date(today.getFullYear(), today.getMonth(), 1, 12);
    selectedDay = dateKey(today);
    highlight = 'all';
    refocus = '[data-today]';
  } else if (button.dataset.highlight) {
    highlight = button.dataset.highlight;
    const estimate = getEstimate(today, countryCode);
    const date = highlight === 'arrival' ? estimate.arrivalMin : highlight === 'dispatch' ? estimate.dispatchMin : today;
    month = new Date(date.getFullYear(), date.getMonth(), 1, 12);
    selectedDay = null;
    refocus = `[data-highlight="${highlight}"]`;
  } else if (button.dataset.day) {
    selectedDay = button.dataset.day;
    refocus = `[data-day="${selectedDay}"]`;
  } else return;
  render();
  section.querySelector(refocus)?.focus({ preventScroll: true });
});

render();
function focusWhenReady() {
  if (location.hash === '#shipping-note') document.fonts.ready.then(() => requestAnimationFrame(() => requestAnimationFrame(() => focusSection())));
}
if (document.readyState === 'complete') focusWhenReady();
else window.addEventListener('load', focusWhenReady, { once: true });
function updateToday() {
  const now = new Date();
  if (dateKey(now) === dateKey(today)) return;
  const followedToday = month.getFullYear() === today.getFullYear() && month.getMonth() === today.getMonth();
  today = now;
  if (followedToday) month = new Date(today.getFullYear(), today.getMonth(), 1, 12);
  selectedDay = null;
  render();
}
setInterval(updateToday, 30000);
document.addEventListener('visibilitychange', () => { if (!document.hidden) updateToday(); });
